// extracted by mini-css-extract-plugin
export default {"pills-container":"fqQFAH"};